import { CheckCircle2, Circle, ArrowRight } from "lucide-react";
import { SectionTitle } from "@/components/platform/PortalLayout";

const NAV_FOR = {
  complete_profile: "profile", confirm_contact: "profile", complete_waiver: "documents",
  review_membership: "membership", view_schedule: "schedule", coach_assignment: "overview",
};

export default function OnboardingChecklist({ items = [], onNav }) {
  const done = items.filter((i) => i.done).length;
  if (!items.length) return null;
  return (
    <div data-testid="onboarding-checklist">
      <SectionTitle>Getting Started · {done}/{items.length}</SectionTitle>
      <div className="bg-[#121212] border border-white/10 divide-y divide-white/5">
        {items.map((it) => (
          <button key={it.key} data-testid={`onboard-${it.key}`}
            onClick={() => !it.done && onNav?.(NAV_FOR[it.key] || "overview")}
            className={`w-full flex items-center gap-3 px-5 py-3.5 text-left transition-colors ${it.done ? "opacity-60" : "hover:bg-white/[0.03]"}`}>
            {it.done ? <CheckCircle2 size={18} className="text-white shrink-0" /> : <Circle size={18} className="text-white/30 shrink-0" />}
            <span className={`flex-1 text-sm ${it.done ? "line-through text-white/40" : "text-white/80"}`}>{it.label}</span>
            {!it.done && <ArrowRight size={15} className="text-white/30" />}
          </button>
        ))}
      </div>
    </div>
  );
}
